<template>
    <div class="setVisitornfo">
        <div class="module-item-style">
            <div class="module-item-title">
                <div>
                    访客信息设置
                </div>
                <div class="setting-tips">可以根据自身需求个性化设置访客信息的名称（建议不超过4个字符）。</div>
                <div class="setting-tips">字段可拖动排序。</div>
            </div>
        </div>

        <div class="module-item-style">
            <div class="setting-visitor-info">
                <el-form class="setting-form" :model="userInfoForm" ref="userInfoForm" label-width="140px">
                        <el-form-item
                                class="setting-form-item"
                                :label='`"姓名"名称`'>
                            <el-input
                                    :disabled="true"
                                    type="text"
                                    value="姓名"
                                    class="input-width"
                                    autocomplete="off"
                                    placeholder="请输入"></el-input>
                            <el-checkbox
                                    :disabled="true"
                                    checked>显示
                            </el-checkbox>
                        </el-form-item>
                    <draggable v-model="configList" @start="drag=true" @end="onEnd">
                        <el-form-item
                                v-for="(item, index) in configList"
                                :key="index"
                                class="setting-form-item"
                                :label='`"${item.displayName}"名称`'>
                            <el-input
                                    :disabled="item.type == 0"
                                    @change="handleChangeShow(item)"
                                    @keyup.native="keyupEvent(item, index)"
                                    @focus="btnDisabled = true"
                                    @blur="btnDisabled = false"
                                    type="text"
                                    v-model="item.displayName"
                                    class="input-width"
                                    autocomplete="off"
                                    placeholder="请输入"></el-input>
                            <el-checkbox
                                    :disabled="item.fieldName == 'name' ? true: false"
                                    @change="handleChangeShow(item, 'noName')"
                                    :false-label="0"
                                    :true-label="1"
                                    v-model="item.isDisplay">显示
                            </el-checkbox>
                            <el-button
									class="delete"
                                    v-if="item.type != 0"
                                    @click="handleClickDelete(item)"
                                    type="danger" size="mini">删除
                            </el-button>
                        </el-form-item>
                    </draggable>
                    <el-form-item>
                        <el-button type="primary" :disabled="btnDisabled" @click="handlerClickAddCustom">添加自定义字段
                        </el-button>
						<el-button type="primary" @click="handlerClickSaveSort">保存排序
						</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {
        visitorFieldDisplayConfig,
        delVisitorField,
        editVisitorField,
        addVisitorField
    } from '@/api/modules/setting/setting-system'

    export default {
        name: 'setting-visitor-info',
        data() {
            return {
                userInfoForm: {
                    realName: '',
                    no: '',
                },
                configList: [],
                btnDisabled: false,
                sortList: [],
				saveSort: true,
            }
        },
        components: {
            draggable
        },
        computed: {
            userData() {
                return this.$store.getters.user
            }
        },
        created() {
            this.visitorFieldDisplayConfigFn()
        },
        mounted() {

        },
        methods: {
            // 获取配置列表
            visitorFieldDisplayConfigFn() {
                this.$http.visitorFieldDisplayConfig().then(res => {
                    if (res.status == 1) {
                        this.configList = res.data
                        this.sortList = []
						this.configList.map((item, index) => {
                            if(item.fieldName === 'name'){
                                this.configList.splice(index,1)
                            }
							
                        })
                        this.configList.map((item, index) => {
                            let srotInit = {
                                    id: '',
                                    sort: ''
                                }
                                srotInit.id = item.id
                                srotInit.sort = item.sort
                                this.sortList.push(srotInit)
							
                        })

                        console.log('this.configList=', this.configList)
                        console.log('this.sortList=', this.sortList)
                    }
                })
            },
            // 键盘弹起事件
            keyupEvent(item, index) {
                let displayName = item.displayName
                // console.log(123123, displayName)
                if (displayName.length > 4) {
                    displayName = displayName.substring(0, 4)
                    this.$set(this.configList[index], 'displayName', displayName)
                }
            },
            // 编辑字段
            handleChangeShow(item, str) {
                const param = {
                    id: item.id,
                    displayName: item.displayName,
                    isDisplay: item.isDisplay
                }
                if(!this.saveSort){
                    this.$message({
                        message:'排序还没保存，请先保存！',
                        type: 'error'
                    })
                    return false
                }
                if (str == 'noName') {
                    param.displayName = null
                    this.$http.editVisitorField(param).then(res => {
                        if (res.status == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            })
                            this.visitorFieldDisplayConfigFn()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            })
                        }
                    })
                } else {
                    if (item.displayName == '') {
                        this.$message({
                            message: '名称不能为空',
                            type: 'error'
                        })
                        // this.visitorFieldDisplayConfigFn()
                        return false
                    }
                    if (item.displayName.length > 4) {
                        this.$message({
                            message: '名称不能大于4个字符',
                            type: 'error'
                        })
                        // this.visitorFieldDisplayConfigFn()
                        return false
                    }
                    this.$http.editVisitorField(param).then(res => {
                        if (res.status == 1) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            })
                            this.visitorFieldDisplayConfigFn()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            })
                        }
                    })
                }
            },
            // 添加自定义字段
            handlerClickAddCustom() {
                const param = {
                    displayName: '自定义',
                    isDisplay: 0
                }
                if(!this.saveSort){
					this.$message({
						message:'排序还没保存，请先保存！',
						type: 'error'
					})
                	return false
				}
                this.$http.addVisitorField(param).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.visitorFieldDisplayConfigFn()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            },
			handlerClickSaveSort(){
				if (this.saveSort) {
					this.$message({
						message: '你没有进行排序，无需操作',
						type: 'error'
					})
					return false
				}
                this.saveSort = true
				this.$http.userInfoSort({
					list: this.sortList
				}).then(res => {
					if (res.status == 1){
					    this.saveSort = true
						this.visitorFieldDisplayConfigFn()
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}

				}).catch(err => {
					console.log('err=', err)
				})
			},
            // 删除自定义字段
            handleClickDelete(item) {
                const param = {
                    id: item.id
                }
                if(!this.saveSort){
                    this.$message({
                        message:'排序还没保存，请先保存！',
                        type: 'error'
                    })
                    return false
                }
                this.$http.delVisitorField(param).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.visitorFieldDisplayConfigFn()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            },
			// 拖拽
			onEnd(e) {
				let newIndex = e.newIndex
				let oldIndex = e.oldIndex
				if (oldIndex > newIndex) {
					// 向上拖
                    this.sortList.splice(newIndex, 0, this.sortList[oldIndex]);
					this.sortList.splice(oldIndex + 1, 1)

				} else {
					// 向下拖
					this.sortList.splice(newIndex + 1, 0, this.sortList[oldIndex]);
					this.sortList.splice(oldIndex, 1)
                }
				this.$nextTick( () => {
                    this.sortList.map((item, i) => {
                        item.sort = i + 1
                    })
                    console.log('this.sortList=', this.sortList)
                })
				this.saveSort = false
			},
            /**
             * 保存修改的个人信息
             * @param formName
             */
            submitUserForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.saveChangeProfileAPI(this.userInfoForm).then(res => {
                            if (res.status == 1) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                })
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    .setVisitornfo {
        .setting-tips {
            color: #999;
            margin-top: 15px;
            font-weight: normal;
        }
		.delete{
			margin-left: 15px;
		}
        .setting-form {
            .input-width {
                width: 240px;
                margin-right: 10px;
            }
        }
    }
</style>
